// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2024-05-16 23:09:36 +0200 (Thu, 16 May 2024) $
//  Author    : Dirk Rothe, Olli Powroznik
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 142881 $
//  Purpose   : wiki parts
// =============================================================================
// ---Third-party imports
import React from 'react'
import {List, Menu, Tab} from 'semantic-ui-react'

// ---Framework imports
import {loadLazy} from 'uix/parts'
import log from 'uix/logging'
import {Sel, Actions} from 'uix/registries'
import {get} from 'ldash'
import {Part} from 'uix/parts'
import {Editor} from 'uix/components/editor'
import {AutoPortal} from 'uix/components'
import {useSelector, useRouter} from 'uix/hooks'

// ---Local imports
import {WikiPane} from '../render'
import {WikiAlternatives} from '../components'

// ---Globals
export const SimpleWikiList = loadLazy(() => import(/* webpackChunkName: 'wiki' */ './simple'))
//~ export const WikiEditor = loadLazy(() => import(/* webpackChunkName: 'wiki' */ './editor'))
export {WikiEditor} from './editor'
export const WikiHistory = loadLazy(() => import(/* webpackChunkName: 'wiki' */ './history'))

export class Wikiblock extends Part {
  _render() {
    let {request, wiki, go, partcfg} = this.props
    let {showMenu = false, showAlternatives = false} = partcfg
    if (!wiki) {
      return null
    }

    let editParams = wiki.otid ? {id: wiki.otid} : {query: {identifier: wiki.identifier}}
    let editWiki = () => go({classname: 'xwiki', tabname: 'edit', ...editParams})

    let menu = (
      <Menu>
        <Menu.Item icon="edit" content={wiki.identifier} onClick={editWiki} />
      </Menu>
    )
    let style = showAlternatives ? {flex: 1, overflow: 'auto'} : {}
    return (
      <>
        {showMenu ? <AutoPortal target="TabMenuPortal">{menu}</AutoPortal> : null}
        <div className="wikiblock" style={style}>
          {wiki.missing ? null : (
            <WikiPane rendered={wiki.rendered} identifier={wiki.identifier} otid={wiki.otid} />
          )}
        </div>
        {showAlternatives && <WikiAlternatives />}
      </>
    )
  }
}
